import speechToTextStore from '@/store/speech';
import CanceledError from './CanceledError';
import { loadModule } from '@/common/loadModule';

class VoiceRecorderAzure {
  speechRecognizer = null;
  opts = {};
  recognizedText = '';

  constructor(opts = {}) {
    this.opts = opts;
    // 识别监听方法
    this.onWillStatusChange = opts.onWillStatusChange || (() => {});
    this.onRecognizing = opts.onRecognizing || (() => {});
    this.onRecognized = opts.onRecognized || (() => {});
    this.onEnded = opts.onEnded || (() => {});
    this.onError = opts.onError || (() => {});
    this.status = 'normal';
    // 方言/语种
    // https://learn.microsoft.com/zh-cn/azure/ai-services/speech-service/language-support?tabs=stt
    this.language = opts.language || 'zh-CN';

    this.init();
  }

  // 操作初始化
  init() {
    loadModule('SpeechSDK').catch(err => false);
  }

  // 修改录音听写状态
  setStatus(status) {
    if (this.status !== status) {
      this.onWillStatusChange?.(this.status, status);
    }
    this.status = status;
  }

  // 启动录音
  async recognizeStart() {
    const speechsdk = window.SpeechSDK;
    const { ResultReason = {} } = speechsdk || {};
    const config = await speechToTextStore.getConfig();
    if (config) {
      this.setStatus('init');

      const speechConfig = speechsdk.SpeechConfig.fromSubscription(
        config.subscriptionKey,
        config.region
      );
      speechConfig.speechRecognitionLanguage = this.language;

      const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput();
      this.speechRecognizer = new speechsdk.SpeechRecognizer(
        speechConfig,
        audioConfig
      );

      this.speechRecognizer.canceled = (_, e) => {
        const messages = [`CANCELED: Reason=${e.reason}`];
        if (e.reason == speechsdk.CancellationReason.Error) {
          messages.push(`ErrorCode=${e.errorCode}`);
          messages.push(`ErrorDetails=${e.errorDetails}`);
        }
        this.onError(new CanceledError(messages.join(' ')));
        this.stopRecognition();
      };

      this.speechRecognizer.recognizing = (_, e) => {
        this.onRecognizing?.(this.recognizedText + e.result.text);
      };

      this.speechRecognizer.recognized = (_, e) => {
        const { reason, text } = e.result;
        switch (reason) {
          case ResultReason.RecognizedSpeech:
            this.recognizedText += text;
            this.onRecognized(this.recognizedText);
            break;
          case ResultReason.NoMatch:
            if (text === undefined) {
              this.onEnded(this.recognizedText);
            }
            break;
          default:
            this.onError(
              new Error(
                [`Recognized Error Reason=${reason}`, `Text=${text}`].join(' ')
              )
            );
            break;
        }

        this.stopRecognition();
      };

      this.speechRecognizer.sessionStopped = () => {
        this.stopRecognition();
      };

      this.setStatus('runing');
      this.speechRecognizer.startContinuousRecognitionAsync();
    } else {
      this.onError(new Error('获取订阅配置失败'));
    }
  }

  // 停止录音
  stopRecognition() {
    this.speechRecognizer?.stopContinuousRecognitionAsync();
    this.speechRecognizer = null;
    this.setStatus('ended');
  }

  // 开始
  start() {
    this.recognizedText = '';
    this.recognizeStart();
  }

  // 停止
  stop() {
    this.stopRecognition();
  }
}

export default VoiceRecorderAzure;
